<div
  fxLayout="column"
  class="kumo-agent-workspace chat-pattern relative"
  [ngClass]="{
    'deployment-chat-shell': type === 'deployment',
    'kumo-agent-workspace--detail': isDetail
  }"
>
  <div class="kumo-agent-workspace__shell w-full overflow-hidden" fxLayout="column">

    <!-- ── Header (original structural classes preserved) ─── -->
    <div
      class="agent-header bg-app-bar border-b"
      fxLayout="row"
      fxLayoutAlign="space-between center"
      fxLayoutGap="16px"
      fxFlex="none"
    >
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
        <div class="agent-logo-wrap" *ngIf="type !== 'deployment'">
          <img  
            loading="lazy"
            decoding="async" 
            src="assets/img/chatbot-ai.png" 
            class="agent-logo-img" alt="KumoAgent" 
          />
        </div>
        <div *ngIf="type !== 'deployment'">
          <div class="agent-name">KumoAgent</div>
          <div class="agent-subtitle"><span class="online-dot">●</span>&nbsp;{{ agentSubtitle }}</div>
        </div>
        <div *ngIf="type === 'deployment'" class="agent-name">Service Conflict Co-Pilot</div>

        <div *ngIf="messages?.length" class="search-inline" fxLayout="row" fxLayoutAlign="start center">
          <ic-icon [icon]="icSearch" class="text-secondary" size="18px"></ic-icon>
          <input type="text" placeholder="Search…" class="search-input"
            (keyup.enter)="goToNextMatch()" [formControl]="searchControl" />
          <ng-container *ngIf="searchControl.value && matchedElements.length">
            <span class="text-xs text-secondary mx-1">{{ currentMatchIndex + 1 }}/{{ matchedElements.length }}</span>
            <button class="search-nav-btn" (click)="goToPreviousMatch()">
              <mat-icon style="font-size:16px;width:16px;height:16px">keyboard_arrow_up</mat-icon>
            </button>
            <button class="search-nav-btn" (click)="goToNextMatch()">
              <mat-icon style="font-size:16px;width:16px;height:16px">keyboard_arrow_down</mat-icon>
            </button>
          </ng-container>
        </div>
      </div>

      <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="2px">
        <button *ngIf="type == 'deployment'" color="primary" mat-raised-button mat-mini-fa (click)="openPreDeploymentDetail()" type="button" class="mr-2" matTooltip="Service Conflict">
          Service Conflict
        </button>
        <button class="agent-action-button fullScreenIcon" mat-icon-button type="button"
          *ngIf="!fullScreen && !hideFSIcon && type !== 'deployment'" (click)="toggleFullScreen(true)"
          matTooltip="Full screen" aria-label="Open KumoAgent full screen" fxFlex="none">
          <mat-icon  [icIcon]="icFullScreen"></mat-icon>
        </button>
        <button mat-icon-button *ngIf="fullScreen && !hideFSIcon" (click)="toggleFullScreen(false)"
          matTooltip="Exit full screen" aria-label="Exit KumoAgent full screen" fxFlex="none" type="button"
          class="agent-action-button">
          <mat-icon [icIcon]="icFullScreenExit"></mat-icon>
        </button>
        <button class="agent-action-button" (click)="exportChat()" [disabled]="!messages?.length"
          matTooltip="Export chat" aria-label="Export KumoAgent chat" type="button" mat-icon-button>
          <mat-icon [icIcon]="icDownload"></mat-icon>
        </button>
        <button class="agent-action-button" (click)="settings()" matTooltip="KumoAgent settings"
          aria-label="Open KumoAgent settings" type="button" mat-icon-button>
          <mat-icon [icIcon]="icSettingOutline"></mat-icon>
        </button>
      </div>
    </div>

    <!-- ── Messages (original structural classes preserved) ── -->
    <div id="chatElement" class="kumo-agent-thread" [style.height]="isDetail ? null : tableHeight">
      <vex-scrollbar class="flex-auto">

        <!-- Conflict spinner -->
        <div fxLayout="row" class="mt-4" fxFlex *ngIf="serviceConflictCopilotLoading">
          <div fxLayout="row" fxLayoutAlign="space-around start" fxFlex>
            <mat-progress-spinner strokeWidth="4" diameter="60" mode="indeterminate" color="primary"></mat-progress-spinner>
          </div>
        </div>

        <!-- Empty / welcome state -->
        <div class="welcome-state" *ngIf="!messages?.length && type !== 'deployment'">
          <div class="welcome-logo-wrap">
            <img
              loading="lazy"
              decoding="async" 
              src="assets/img/chatbot-ai.png" 
              class="welcome-logo-img" alt="KumoAgent" 
            />
          </div>
          <h2 class="welcome-heading">Hi {{ layoutService.userName }}</h2>
          <p class="welcome-sub">{{ agentSubtitle }} · Ask me anything about your infrastructure</p>
          <div class="quick-chips">
            <button *ngFor="let feature of features;  trackBy:trackByFeaturesId" 
              class="quick-chip" 
              (click)="setFeatures(feature)">
              {{ feature.title }}
            </button>
          </div>
        </div>

        <!-- Message thread -->
        <ng-container *ngFor="let message of messages;trackBy:trackByMessageId">

          <!-- User message -->
          <ng-container *ngIf="message.from === 'me'">
            <div class="user-turn">
              <div class="user-content">
                <div class="user-bubble">
                  <span [innerHTML]="message.highlightedMessage || message.textMessage"></span>
                  <div *ngIf="message.isFileUpload" class="file-attach-label">{{ message.fileDetails }}</div>
                </div>
                <div class="turn-meta" style="justify-content:flex-end">
                  <span class="text-xs text-secondary">{{ message.timestamp }}</span>
                </div>
              </div>
              <div class="user-avatar-circle">
                {{ layoutService.userName?.charAt(0)?.toUpperCase() || 'U' }}
              </div>
            </div>
          </ng-container>

          <!-- AI message -->
          <ng-container *ngIf="message.from === 'partner'">
            <div class="ai-turn">
              <img  
                loading="lazy"
                decoding="async" 
                src="assets/img/chatbot-ai.png" 
                class="ai-avatar-img flex-shrink-0" alt="KA" 
              />
              <div class="ai-content">

                <!-- Reasoning steps -->
                <div *ngIf="message.steps?.length" class="steps-panel">
                  <div class="steps-toggle" (click)="message.stepsExpanded = !message.stepsExpanded">
                    <mat-icon class="steps-chevron">{{ message.stepsExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
                    <span>{{ message.steps.length }} step{{ message.steps.length !== 1 ? 's' : '' }}</span>
                    <span *ngIf="hasLoadingSteps(message.steps)" class="thinking-label">thinking…</span>
                  </div>
                  <div *ngIf="message.stepsExpanded" class="steps-body">
                    <div *ngFor="let step of message.steps;trackBy:trackByMessageId" class="step-row">
                      <mat-spinner *ngIf="step.status === 'loading'" diameter="12" color="primary"></mat-spinner>
                      <mat-icon *ngIf="step.status === 'done'" class="step-done">check_circle</mat-icon>
                      <span class="step-name">{{ step.name }}</span>
                      <span *ngIf="step.summary" class="step-summary">— {{ step.summary }}</span>
                    </div>
                  </div>
                </div>

                <!-- Response -->
                <div class="ai-body" (click)="onMarkdownClick($event)">
                  <markdown class="markdown"
                    [data]="message.highlightedMarkdown || message.message"
                    #markdownContent></markdown>
                  <span *ngIf="!message.isCompleted && !hasLoadingSteps(message.steps)" class="streaming-cursor">▌</span>
                </div>

                <!-- Actions -->
                <div class="turn-meta message-actions">
                  <span class="text-xs text-secondary">{{ message.timestamp }}</span>
                  <mat-icon class="action-icon" matTooltip="Copy" (click)="copyToClipboard(markdownContent, message)">
                    {{ message.isCopied ? 'check_circle' : 'file_copy' }}
                  </mat-icon>
                  <ng-container *ngIf="message.isCompleted">
                    <mat-icon class="action-icon" [class.rated-up]="message.rating === 'up'"
                      matTooltip="Helpful" (click)="rateMessage(message, 'up')">thumb_up</mat-icon>
                    <mat-icon class="action-icon" [class.rated-down]="message.rating === 'down'"
                      matTooltip="Not helpful" (click)="rateMessage(message, 'down')">thumb_down</mat-icon>
                    <mat-icon *ngIf="message === messages[messages.length - 1]"
                      class="action-icon" matTooltip="Regenerate" (click)="regenerate()">refresh</mat-icon>
                  </ng-container>
                </div>

              </div>
            </div>
          </ng-container>

        </ng-container>

        <!-- Typing indicator -->
        <ng-container *ngIf="fetchingAiResponse && !messages[messages.length - 1]?.steps?.length">
          <div class="ai-turn">
            <img
              loading="lazy"
              decoding="async"
              src="assets/img/chatbot-ai.png" 
              class="ai-avatar-img flex-shrink-0" alt="KA" 
            />
            <div class="ai-content">
              <div class="ai-body thinking-row">
                <div class="typing-indicator"><span></span><span></span><span></span></div>
                <span class="thinking-text">{{ thinkingLabel }}</span>
              </div>
            </div>
          </div>
        </ng-container>

      </vex-scrollbar>
    </div>

    <!-- ── Input (original structural classes preserved) ──── -->
    <div class="input-area p-4 bg-app-bar border-t" *ngIf="formChat">
      <form (ngSubmit)="send()" [formGroup]="formChat">
        <div class="prompt-box">
          <button mat-icon-button type="button" [matMenuTriggerFor]="uploadFileMenu"
            class="attach-btn" matTooltip="Attach file">
            <mat-icon style="font-size:20px">attach_file</mat-icon>
          </button>
          <mat-menu #uploadFileMenu="matMenu">
            <button mat-menu-item (click)="triggerFileUpload()">
              <mat-icon class="text-secondary">attach_file</mat-icon>
              <span>Upload file (.tf, .json, .yaml, .txt)</span>
            </button>
          </mat-menu>

          <div class="prompt-inner">
            <textarea class="prompt-textarea" formControlName="message"
              placeholder="Ask KumoAgent anything…" rows="1"
              (keydown)="handleKeydown($event)"
              (input)="autoResize($event)"
              #textarea></textarea>
            <div *ngIf="uploadedFileName" class="file-pill">
              <mat-icon style="font-size:13px;width:13px;height:13px">attach_file</mat-icon>
              {{ uploadedFileName }}
              <button type="button" mat-icon-button (click)="removeUploadedFile()"
                style="width:20px;height:20px;line-height:20px">
                <mat-icon style="font-size:13px">close</mat-icon>
              </button>
            </div>
            <div *ngIf="fileError" class="text-xs text-red mt-1">{{ fileError }}</div>
          </div>

          <button mat-icon-button type="submit"
            class="send-btn" [class.send-active]="hasValidInput()"
            [disabled]="!hasValidInput() || fetchingAiResponse"
            matTooltip="Send (Enter)">
            <mat-icon [icIcon]="icSend"></mat-icon>
          </button>
        </div>
      </form>
    </div>

  </div>
</div>
